import React from 'react';
import { useSelector } from 'react-redux';
import { currentPageState$ } from '../../redux/selectors';
import './styles.css';

const socialLinks = {
    github: 'https://github.com/QuocDung0209',
    facebook: 'https://www.facebook.com/quocdung02091997',
    name: 'DungNguyen',
}

export default function Footer() {
    const currentPage = useSelector(currentPageState$);

    if (currentPage === 'login') {
        return null;
    }

    const year = new Date().getFullYear();

    return (
        <div className="container-fluid">
            <div className="row justify-content-between align-items-center footer">
                <div className="col-auto">
                    <div className="social-links">
                        <a href={socialLinks.github} target="_blank" rel="noreferrer"><i className="fa fa-github"></i></a>
                        <a href={socialLinks.facebook} target="_blank" rel="noreferrer"><i className="fa fa-facebook"></i></a>
                        {/* <a href=""><i className="fa fa-instagram"></i></a>
                        <a href=""> <i className="fa fa-linkedin"></i> </a> */}
                    </div>
                </div>
                <div className="col-auto"><b>{socialLinks.name}</b> &copy; {year}</div>
            </div>
        </div>
    )
}